module.exports = __webpack_public_path__ + "img/37232-022.7ee16cb4.jpg";